import { useState } from 'react';
import './AddPoints';
import Header from './Header';
import { useAuth } from '../context/AuthContext';
import Swal from 'sweetalert2';
import AddPointsEventSevices from '../services/AddPointsEventSevices';
import './AddPoints.css'

const AddPoints = () => {
    const [formData, setFormData] = useState({
        dni: '',
        type_points: '',
        points: '',
    });
    const [cedula, setCedula] = useState('');

    const { token } = useAuth();

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });

        setCedula(formData.dni);
    }

    const translations = {
        PICTURE: 'subir tu fotografía',
        POINTS: 'participar en grita gol'
    };

    // Función para traducir y convertir a minúsculas
    const translateAndLowerCase = (str) => {
        const translation = translations[str];
        return translation ? translation.toLowerCase() : str.toLowerCase();
    };

    const handleCreateEvent = async (e) => {
        e.preventDefault();
        try {
            await AddPointsEventSevices(token, formData);

            Swal.fire({
                title: '!puntos añadidos!',
                icon: "success",
                text: 'el participante con cédula ' + formData.dni + ' se le han añadido ' + formData.points + ' puntos por ' + translateAndLowerCase(formData.type_points),
                confirmButtonText: 'cerrar',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
            });

            setFormData({
                dni: cedula,
                type_points: '',
                points: ''
            });
        } catch (error) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: error.message,
                customClass: {
                    title: "text-center"
                },
                showConfirmButton: false, // Mostrar el botón de confirmación
                timer: 2500,
                timerProgressBar: true,
            });

        }
    }

    return (
        <div className="events-container w-100">
            <Header />
            <div className="row external-bg-container-include d-flex justify-content-center align-items-start pt-5 vh-100 overflow-y-scroll">
                <div className="w-100 container d-flex justify-content-center align-items-center flex-column mt-5">
                    <div className="col-12 col-lg-6 mx-3 d-flex justify-content-center align-items-center flex-column mt-5">
                        <h1 className="title-login-sesion Bebas-Neue mt-5">añadir puntaje</h1>
                        <form className="login-form w-75 d-flex justify-content-center align-items-center flex-column" onSubmit={handleCreateEvent}>
                            <input
                                type="number"
                                name='dni'
                                className="text-red form-container-input text-center"
                                placeholder="cédula del participante"
                                value={formData.dni}
                                onChange={handleChange}
                                title="Ingrese un correo electrónico válido"
                                required
                            />

                            <select
                                className="text-red form-container-input text-center"
                                value={formData.type_points}
                                name='type_points'
                                onChange={handleChange}
                                aria-label="Seleccione el tipo de puntos">
                                <option>Seleccione el tipo</option>
                                <option value="PICTURE">fotografía</option>
                                <option value="POINTS">puntos </option>
                            </select>

                            <input
                                type="number"
                                name="points"
                                className="text-red form-container-input text-center"
                                placeholder="cantidad puntos ganados"
                                value={formData.points}
                                onChange={handleChange}
                                title="Ingrese un correo electrónico válido"
                                required
                            />

                            <button type="submit" className="form-container-button w-70 lowercase">añadir puntos</button>
                        </form>
                    </div>
                    <div className="col-12 col-lg-6 mx-3 d-flex justify-content-center align-items-center">
                        <img src="./aviancaLogo.png" className="container-logo-events" alt="avianca" />
                    </div>
                </div>
                {/* footer mobile */}
                <footer className="d-block d-md-block d-lg-none d-xl-none col-12 mt-auto">
                    <div className="d-flex justify-content-between align-items-center text-white mb-2">
                        <div className='mx-4 mb-3'>
                            <img src="./Logo-Footer-1.png" style={{ width: '70%' }} alt="logo" />
                        </div>
                        <div className='text-end mx-4 mb-3'>
                            <img src="./Logo-Footer-2.png" style={{ width: '150%', marginLeft: '-85px' }} alt="logo" />
                        </div>
                    </div>
                </footer>
                <footer className="d-none d-md-block d-lg-block d-xl-block col-12 mt-auto col-12 mt-auto bg-transparent">
                    <div className="d-flex justify-content-between align-items-center text-white mb-2">
                        <div className='mx-4 mb-3'>
                            <img src="./Logo-Footer-1.png" style={{ width: '40%' }} alt="logo" />
                        </div>
                        <div className='text-end mx-4 mb-3'>
                            <img src="./Logo-Footer-2.png" style={{ width: '60%' }} alt="logo" />
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    )
}

export default AddPoints